import { forwardRef } from 'react'

// Responsive grid: auto-fits as many `min`-wide columns as fit, else fewer.
// Collapses to one column on narrow widths without any breakpoint.
// Forwards ref to the root so callers can attach motion hooks (e.g. useEnterStagger).
const Grid = forwardRef(function Grid({ min = '220px', gap = '16px', className = '', style, children, ...rest }, ref) {
  return (
    <div
      ref={ref}
      className={`cn-grid ${className}`.trim()}
      style={{ '--cn-grid-min': min, '--cn-grid-gap': gap, ...style }}
      {...rest}
    >
      {children}
    </div>
  )
})

export default Grid
